import { columns } from './columns';
import { filters } from './filters';
import { query } from './query';

const errorTypeConfig = {
    columns,
    filters,
    queryFilter: query,
};

export default errorTypeConfig;
